import { render, staticRenderFns } from "./kra-stake-tax.vue?vue&type=template&id=b2ecb05e&scoped=true&"
import script from "./kra-stake-tax.vue?vue&type=script&lang=js&"
export * from "./kra-stake-tax.vue?vue&type=script&lang=js&"
import style0 from "./kra-stake-tax.vue?vue&type=style&index=0&id=b2ecb05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ecb05e",
  null
  
)

export default component.exports